import { render } from "./Label.vue?vue&type=template&id=bc75442c"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
script.render = render

export default script